// profile.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProfileDto } from '../models/ProfileDto';
import { UrlConstants } from '../models/url-constants';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private readonly http: HttpClient) { }

  getProfile(): Observable<ProfileDto> {
    return this.http.get<ProfileDto>(UrlConstants.USER_PROFILE_URL);
  }

  saveTerms(): Observable<any> {
    return this.http.post(`${UrlConstants.TERMS_AND_CONDITIONS_URL}`, {});
  }
}
